import React, { useEffect } from "react";
import style from "./JobsPost.module.css";
// import LinkGen from "../../../Blog/LinkGen";
import { Link } from "react-router-dom";
import {
  FaLink as LinkIcon,
  FaMapMarkerAlt as Location,
  FaRegCalendarAlt as Calendar,
} from "react-icons/fa";
function JobsPost({ data }) {
  useEffect(() => {
    document.title = `${data.title} | InvoZone`;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [data.title]);
  return (
    <div className={style.mainContainer}>
      <div className={style.wrapper}>
        <div className={style.headingDiv}>
          <h1 className={style.heading}>{data.title}</h1>
          <div className={style.detailDiv}>
            <div
              className={`${style.type} ${
                data.partTime ? style.partTime : style.fullTime
              }`}
            >
              {data.type}
            </div>
            <div className={style.city}>
              <Location className={style.icon} />
              {data.city}
            </div>

            <div className={style.date}>
              <Calendar className={style.icon} />
              {`Posted on ${data.date}`}
            </div>
          </div>
        </div>
        <div className={style.invoZoneCard}>
          <div className={style.imageDiv}>
            <img
              src="https://invozone.com/wp-content/uploads/2020/04/favicon.svg"
              alt=""
              className={style.fig}
            ></img>
          </div>
          <div className={style.nameSlogan}>
            <h6 className={style.name}>InvoZone</h6>
            <span className={style.slogan}>
              We push limits with innovative solutions.
            </span>
          </div>
          <div className={style.webLink}>
            <a href="https://www.invozone.com">
              <LinkIcon className={style.linkIcon} />
              Website
            </a>
          </div>
        </div>
        <div className={style.description}>
          <span className={style.description}>
            {data.description.companyDetail}
          </span>
        </div>
        <ul className={style.listContainer}>
          <span className={style.listHeader}>Responsibilites</span>
          {data.description.responsibilites.map(
            (data, index) => (
              <li key={index} className={style.listItem}>
                {data}
              </li>
            ),
            []
          )}
        </ul>
        <ul className={style.listContainer}>
          <span className={style.listHeader}>Must Have</span>

          {data.description.mustHave.map(
            (data, index) => (
              <li key={index} className={style.listItem}>
                {data}
              </li>
            ),
            []
          )}
        </ul>
        <ul className={style.listContainer}>
          <span className={style.listHeader}>Perks</span>

          {data.description.perksBenefits.map(
            (data, index) => (
              <li key={index} className={style.listItem}>
                {data}
              </li>
            ),
            []
          )}
        </ul>
        <Link to="/become-an-employee">
          <button className={style.btn}>Apply for Job</button>
        </Link>

        <p className={style.emailText}>
          To Apply Send an email to{" "}
          <a href="emailTo:hr@invozone.com">hr@invozone.com</a>
        </p>
      </div>
    </div>
  );
}

export default JobsPost;
